module.exports = __webpack_public_path__ + "media/images/bt-intermunicipal-7187801eabf184ce7d6a71c012f68510.svg";